import React, { useEffect, useRef } from 'react'

import videojs from 'video.js'

import 'video.js/dist/video-js.css'
import styles from '../styles/VideoJS.module.css'

const clearPosterAfterVideoLoads = (player, poster) => {
  const clearPoster = () => {
    if (player.isDisposed() || player.poster() !== poster) {
      return
    }

    player.poster('')
  }

  player.one('loadeddata', clearPoster)
  player.one('playing', clearPoster)
}

export const VideoJS = (props) => {
  const videoRef = useRef(null)
  const playerRef = useRef(null)
  const { options, onReady } = props

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('vjs-big-play-centered')
      videoRef.current.appendChild(videoElement)
      if (options.poster) {
        videoElement.setAttribute('poster', options.poster)
      }
      // Set playsinline attributes to prevent fullscreen on iOS Safari
      if (options.playsinline) {
        videoElement.setAttribute('playsinline', 'true')
        videoElement.setAttribute('webkit-playsinline', 'true')
      }

      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
      }))
      clearPosterAfterVideoLoads(player, options.poster)
    } else {
      const player = playerRef.current

      player.autoplay(options.autoplay)
      player.poster(options.poster)
      clearPosterAfterVideoLoads(player, options.poster)
      player.src(options.sources)
      const playPromise = player.play()
      if (playPromise !== undefined) {
        playPromise.catch(() => {})
      }
    }
  }, [options])

  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [])

  return (
    <div data-vjs-player>
      <div className={styles['video-container']} ref={videoRef} />
    </div>
  )
}

export default VideoJS
